import type { AppContextType } from "@shared/graphql.apollo";

import React from "react";
import { AppContext } from "utils/app-context";

export const useAppContext = (): AppContextType => {
  return React.useContext(AppContext);
};
